export interface AvatarProperties {
    username?: string;
    seed?: string;
    score?: number;
}

export enum AvatarSide {
    Left = "left",
    Right = "right",
}
